<div
	class="tutorial-overlay"
	[hidden]="isForbiddenRoute() || !showTutorial"
	(click)="handleOverlayAction()"
	(keyup.enter)="handleOverlayAction()"
	(keyup.escape)="handleOverlayAction()"
	[style.font-size]="fontSize"
	tabindex="0"
	role="dialog"
	[attr.aria-label]="
		(tutorialConfig?.LOOK_AROUND | translate) +
		'. ' +
		(isMobileLayout && mobilePhase === 'items'
			? (tutorialConfig?.TAP_ANYWHERE_TO_CONTINUE | translate)
			: (tutorialConfig?.TAP_ANYWHERE_TO_CLOSE | translate))
	"
>
	<!-- Desktop: show all content at once -->
	<ng-container *ngIf="!isMobileLayout">
		<div class="tutorial-overlay-top-right">
			<div
				style="right: 0px; text-align: center; position: absolute; overflow: visible"
				*ngIf="showBellNotification"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_1"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m110,50 Q 150,10 210,20"
						marker-end="url(#pointer_1)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 160px; top: 55px">
					{{ tutorialConfig?.NOTIFICATIONS_TITLE | translate }}</span
				>
			</div>
			<div
				style="right: 0px; text-align: center; position: absolute; overflow: visible"
				*ngIf="showAccountSelector"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_2"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m145,50 Q 160,50 210,40"
						marker-end="url(#pointer_2)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 160px; top: 40px">{{
					tutorialConfig?.TU_ACCOUNT_SELECTOR_TITLE | translate
				}}</span>
			</div>
			<div style="right: 0px; text-align: center; position: absolute; overflow: visible">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_2"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m230,90 Q 245,75 260,50"
						marker-end="url(#pointer_2)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 71px; top: 89px">{{
					tutorialConfig?.USER_SETTINGS_TITLE | translate
				}}</span>
			</div>
			<div
				style="right: 0px; position: absolute; top: 60px"
				*ngIf="showAccountActionsMenu && tutorialConfig?.ACTIONS_MENU"
			>
				<ion-fab-button size="small" color="primary" style="opacity: 0.4">
					<fa-icon [icon]="faEllipsisV" style="color: #fff"></fa-icon
				></ion-fab-button>
			</div>
			<div
				style="width: 70px; right: 20px; text-align: center; position: absolute; overflow: visible; top: 15px"
				*ngIf="showAccountActionsMenu && tutorialConfig?.ACTIONS_MENU"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="color: #ffffff; width: 50px; position: relative; height: 140px; display: block; margin: auto"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_3"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m30,140 Q 15,120 35,100"
						marker-end="url(#pointer_3)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px">{{
					tutorialConfig?.ACTIONS_MENU | translate
				}}</span>
			</div>
		</div>
		<div class="tutorial-center">
			<h2>
				{{ tutorialConfig?.LOOK_AROUND | translate }}
			</h2>
			{{ tutorialConfig?.TAP_ANYWHERE_TO_CLOSE | translate }}
		</div>

		<div class="tutorial-desktop">
			<div
				id="menuItemsList_{{ i }}"
				*ngFor="let menuItem of tutorialConfig?.tutorialItems; index as i"
				[ngStyle]="getArrowStyle(i)"
			>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; left: 55px; top: 55px">{{
					menuItem.TUTORIAL_MENU_ITEM_NAME | translate
				}}</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_4_{{ i }}"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m50,65 Q 25,70 10,70"
						[attr.marker-end]="'url(#pointer_4_' + i + ')'"
					/>
				</svg>
			</div>
		</div>
	</ng-container>

	<!-- Mobile Phase 1: Show menu item arrows only + "Tap anywhere to continue" -->
	<ng-container *ngIf="isMobileLayout && mobilePhase === 'items'">
		<div class="tutorial-center tutorial-center-top">
			<h2>
				{{ tutorialConfig?.LOOK_AROUND | translate }}
			</h2>
			{{ tutorialConfig?.TAP_ANYWHERE_TO_CONTINUE | translate }}
		</div>

		<div class="tutorial-mobile">
			<div
				id="menuItemsListMobile_{{ i }}"
				*ngFor="let menuItem of tutorialConfig?.tutorialMobileItems; index as i"
				[ngStyle]="getMobileArrowStyle(i)"
			>
				<span
					[ngStyle]="{
						'word-break': 'keep-all',
						'padding-left': '3px',
						position: 'relative',
						top: menuItem.POSITION_TOP,
						left: menuItem.POSITION_TEXT_OFFSET_LEFT || '0px'
					}"
				>
					{{ menuItem.TUTORIAL_MENU_ITEM_NAME | translate }}
				</span>

				<svg
					xmlns="http://www.w3.org/2000/svg"
					[ngStyle]="{
						color: '#ffffff',
						width: '60px',
						position: 'relative',
						height: menuItem.POSITION_ARROW_HEIGHT,
						display: 'block',
						margin: 'auto',
						overflow: 'visible'
					}"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_5_{{ i }}"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>

					<path
						id="{{ menuItem.TUTORIAL_MENU_ITEM_NAME | translate }}"
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m10,0 Q -10,70 10,140"
						[attr.marker-end]="'url(#pointer_5_' + i + ')'"
						*ngIf="menuItem.MOBILE_TUTORIAL_ITEM_PATH_ID == 1"
					/>

					<path
						id="{{ menuItem.TUTORIAL_MENU_ITEM_NAME | translate }}"
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m30,40 Q 35,65 40,90"
						[attr.marker-end]="'url(#pointer_5_' + i + ')'"
						*ngIf="menuItem.MOBILE_TUTORIAL_ITEM_PATH_ID == 2"
					/>

					<path
						id="{{ menuItem.TUTORIAL_MENU_ITEM_NAME | translate }}"
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m20,0 Q 35,65 30,90"
						[attr.marker-end]="'url(#pointer_5_' + i + ')'"
						*ngIf="menuItem.MOBILE_TUTORIAL_ITEM_PATH_ID == 3"
					/>

					<path
						id="{{ menuItem.TUTORIAL_MENU_ITEM_NAME | translate }}"
						fill="none"
						stroke="white"
						stroke-width="2"
						d="M -60,0 C 10,40 30,100 60,140"
						[attr.marker-end]="'url(#pointer_5_' + i + ')'"
						*ngIf="menuItem.MOBILE_TUTORIAL_ITEM_PATH_ID == 4"
					/>
				</svg>
			</div>
		</div>
	</ng-container>

	<!-- Mobile Phase 2: Show header items (notifications, settings, actions) + "Tap anywhere to close" -->
	<ng-container *ngIf="isMobileLayout && mobilePhase === 'header'">
		<div class="tutorial-overlay-top-right">
			<div
				style="right: 0px; text-align: center; position: absolute; overflow: visible"
				*ngIf="showBellNotification"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_1_m"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m110,50 Q 150,10 210,20"
						marker-end="url(#pointer_1_m)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 160px; top: 55px">
					{{ tutorialConfig?.NOTIFICATIONS_TITLE | translate }}</span
				>
			</div>
			<div
				style="right: 0px; text-align: center; position: absolute; overflow: visible"
				*ngIf="showAccountSelector"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_2_m"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m145,50 Q 160,50 210,40"
						marker-end="url(#pointer_2_m)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 160px; top: 40px">{{
					tutorialConfig?.TU_ACCOUNT_SELECTOR_TITLE | translate
				}}</span>
			</div>
			<div style="right: 0px; text-align: center; position: absolute; overflow: visible">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="
						color: #ffffff;
						width: 300px;
						position: relative;
						height: 100px;
						display: block;
						margin: auto;
					"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_2b_m"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m230,90 Q 245,75 260,50"
						marker-end="url(#pointer_2b_m)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px; position: absolute; right: 71px; top: 89px">{{
					tutorialConfig?.USER_SETTINGS_TITLE | translate
				}}</span>
			</div>
			<div
				style="right: 0px; position: absolute; top: 60px"
				*ngIf="showAccountActionsMenu && tutorialConfig?.ACTIONS_MENU"
			>
				<ion-fab-button size="small" color="primary" style="opacity: 0.4">
					<fa-icon [icon]="faEllipsisV" style="color: #fff"></fa-icon
				></ion-fab-button>
			</div>
			<div
				style="width: 70px; right: 20px; text-align: center; position: absolute; overflow: visible; top: 15px"
				*ngIf="showAccountActionsMenu && tutorialConfig?.ACTIONS_MENU"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					style="color: #ffffff; width: 50px; position: relative; height: 140px; display: block; margin: auto"
				>
					<defs>
						<marker
							fill="white"
							id="pointer_3_m"
							viewBox="0 0 10 10"
							refX="5"
							refY="5"
							markerWidth="6"
							markerHeight="6"
							orient="auto-start-reverse"
						>
							<path stroke="white" d="M 0 0 L 10 5 L 0 10 z" />
						</marker>
					</defs>
					<path
						fill="none"
						stroke="white"
						stroke-width="2"
						d="m30,140 Q 15,120 35,100"
						marker-end="url(#pointer_3_m)"
					/>
				</svg>
				<span style="word-break: keep-all; padding-left: 3px">{{
					tutorialConfig?.ACTIONS_MENU | translate
				}}</span>
			</div>
		</div>

		<div class="tutorial-center tutorial-center-bottom">
			{{ tutorialConfig?.TAP_ANYWHERE_TO_CLOSE | translate }}
		</div>
	</ng-container>
</div>
